import Scrollbars from 'rc-scrollbars'

const CustomScrollbar = ({ children, ...rest }: any) => {
  const thumbVertical = ({ style, ...props }: any) => {
    const finalStyle = {
      ...style,
      cursor: 'pointer',
      backgroundColor: '#8fd6e7',
    }
    return <div style={finalStyle} {...props} />
  }

  const thumbHorizontal = ({ style, ...props }: any) => {
    const finalStyle = {
      ...style,
      cursor: 'pointer',
      backgroundColor: '#8fd6e7',
    }
    return <div style={finalStyle} {...props} />
  }

  return (
    <Scrollbars
      autoHide
      renderThumbHorizontal={thumbHorizontal}
      renderThumbVertical={thumbVertical}
      {...rest}
    >
      {children}
    </Scrollbars>
  )
}

export default CustomScrollbar
